export default {
    400: 'Bad Request',
    401: "未授权",
    403: "未授权",
    404: "未找到接口地址",
    409: "接口超时,未返回数据",
    500: "内部服务器错误",
    502: "错误的网关",
    503: "暂停服务",
    504: "网关超时",
    505: "不支持 HTTP 版本",
}
